export const GET_INDUSTRY_CATEGORIES_WATCHER = 'GET_INDUSTRY_CATEGORIES_WATCHER';
export const GET_INDUSTRY_CATEGORIES_SUCCESS = 'GET_INDUSTRY_CATEGORIES_SUCCESS';
export const GET_INDUSTRY_CATEGORIES_FAILED = 'GET_INDUSTRY_CATEGORIES_FAILED';
